import { useQuery } from "@tanstack/react-query";
import api from "../lib/apiClient";

export const useContent = () => {
	return useQuery({
		queryKey: ["content"],
		queryFn: async () => {
			const { data } = await api.get("/content");
			return data;
		},
	});
};